import React from 'react';
import { getRandomInt } from '../Helpers/helpers'

const RandomImg = (props) => {
  return (
    <figure className="image">
      <img src={"/imgs/location-" + getRandomInt() + "-color.jpg"} alt={props.location} />
    </figure>
  )
}

export default RandomImg;



// WEBPACK FOOTER //
// ./src/Components/randomimg.js